export default __webpack_public_path__ + "static/circle-economy-mobile-banner-99a8135d5e2d5fb89de5fe14158793cc.png";